import { zodResolver } from "@hookform/resolvers/zod";
import { Stack, Typography } from "@mui/material";
import {
  type FormData,
  schema,
} from "Components/Migration/MerchantCreateIdentity/ManualEntryForm/schema";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { DateFormInput } from "Components/Shared/Inputs/Form/DateFormInput";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";
import { useForm } from "react-hook-form";

const COMPONENT_RESOURCES = Resources.Auth.Migration.MerchantCreateIdentity;

type Props = {
  hasCandidates: boolean;
  isPending: boolean;
  isSubmitDisabled: boolean;
  onSubmit: (data: FormData) => void;
};

export const ManualEntryForm = ({
  hasCandidates,
  isPending,
  isSubmitDisabled,
  onSubmit,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useResource();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: { firstName: "", lastName: "", birthDate: null, phone: "" },
  });

  if (!isOpen) {
    return (
      <PrimaryButton
        variant="outlined"
        color="secondary"
        onClick={() => setIsOpen(true)}
        disabled={isPending}
      >
        {hasCandidates
          ? t(COMPONENT_RESOURCES.ManualEntryToggle)
          : t(COMPONENT_RESOURCES.ManualEntryToggleEmpty)}
      </PrimaryButton>
    );
  }

  return (
    <Stack component="form" gap={2} onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="subtitle2">
        {t(COMPONENT_RESOURCES.ManualTitle)}
      </Typography>
      <FormInput
        name="firstName"
        control={control}
        errors={errors}
        label={t(COMPONENT_RESOURCES.FirstNameLabel)}
      />
      <FormInput
        name="lastName"
        control={control}
        errors={errors}
        label={t(COMPONENT_RESOURCES.LastNameLabel)}
      />
      <DateFormInput
        name="birthDate"
        control={control}
        label={t(COMPONENT_RESOURCES.BirthDateLabel)}
      />
      <FormInput
        name="phone"
        control={control}
        errors={errors}
        label={t(COMPONENT_RESOURCES.PhoneLabel)}
      />
      <PrimaryButton
        type="submit"
        variant="contained"
        color="primary"
        disabled={isSubmitDisabled}
      >
        {t(COMPONENT_RESOURCES.SubmitManualButton)}
      </PrimaryButton>
    </Stack>
  );
};
